module.exports = __webpack_public_path__ + "img/jacket-right-sub-setIn-zipper.8dfc014e.png";